import { classNames } from "@circle-react/helpers/twMergeWithCN";
import type { ReactNode } from "react";

export interface ContentProps {
  children?: ReactNode;
  isCollapsed?: boolean;
}

export const Content = ({
  children = null,
  isCollapsed = false,
}: ContentProps) => (
  <div
    aria-hidden={isCollapsed}
    className={classNames(
      "grid overflow-hidden transition-[grid-template-rows,margin-top] duration-200 ease-out motion-reduce:transition-none",
      isCollapsed ? "mt-0 grid-rows-[0fr]" : "mt-1 grid-rows-[1fr]",
    )}
  >
    <div
      className="min-h-0 overflow-hidden"
      {...(isCollapsed && { inert: true })}
    >
      {children}
    </div>
  </div>
);
